export default "__VITE_ASSET__1c4aa08d__"